var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.713,
    height: 15,
    viewBox: "0 0 17.713 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-revert",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Reply",
    d: "M8.3,3.25a.873.873,0,0,1,.954-.18.887.887,0,0,1,.535.815v2.7a10.514,10.514,0,0,1,9.929,10.526.884.884,0,0,1-.66.858.865.865,0,0,1-.218.027.876.876,0,0,1-.77-.46l-.014-.026a8.688,8.688,0,0,0-7.608-4.519h-.66v2.691a.887.887,0,0,1-.535.815h0a.872.872,0,0,1-.953-.181l-6.027-5.9a.889.889,0,0,1,0-1.271ZM4.138,9.785l3.891,3.808V12.109a.882.882,0,0,1,.878-.885h1.538a10.405,10.405,0,0,1,6.881,2.606A8.713,8.713,0,0,0,9.261,8.346H8.906a.882.882,0,0,1-.878-.885V5.977Z",
    transform: "translate(-2 -3)",
    fill: "#888",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevert);
export default __webpack_public_path__ + "static/media/revert.bcb6585db47252cc168af2aaa522468a.svg";
export { ForwardRef as ReactComponent };